<sh-notification
    [type]="notificationType.Error"
    [title]="'tasks.detail.unknown.title' | translate"
    [message]="'tasks.detail.unknown.message' | translate:{name: name}"
    [icon]="'delete'"
></sh-notification>
